import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs/Rx';
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { CareerReportApi } from "../../shared/nestjs/gd-only/services/career-report.api";
import { LoopBackAuth } from "../../shared/sdk";
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { RequestDownloadExcelDto, RequestDownloadPdfDto } from './../../shared/nestjs/gd-only/dto/career-report.dto';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { ViewCareerReportApi } from './../../shared/sdk/services/custom/ViewCareerReport';
@Injectable()
export class CareerReportBloc {

    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private careerReportApi : CareerReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        public viewCareerReportsApi: ViewCareerReportApi,
        private analyticsProvider: AnalyticsProvider,
    ){}

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Career Report')
        } else {
            saveAs(data, 'Career Report.xlsx')
        }
    }

    downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.careerReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        console.log(data,"data")
        return new Promise(async (resolve, reject) => {
            
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Career Report')
        } else {
            saveAs(data, 'Career Report.pdf')
        }
    }

    downloadPdf(data: RequestDownloadPdfDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.careerReportApi.downloadPdf(data);
    }

    downloadPdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            
        })
    }

    sendExcel(data): Observable<any> {
        let dataExcel ={};
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) { 
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.careerReportApi.reportSendEmailExcel(data);
                } else {
                    dataExcel = {
                              fullName: data.fullName,
                              emailUser: data.email,
                              sendEmail: true,
                              careertranstype: { 'inq': data.careertype },
                            }
                    return this.viewCareerReportsApi.download(dataExcel);
                }
            })
    }

    sendPdf(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.careerReportApi.reportSendEmailPdf(data);
                } else {
                    data = {
                        fullName: data.fullName,
                        emailUser: data.email,
                        sendEmail: true,
                        careertranstype: { 'inq': data.careertype },
                      }
                    return this.viewCareerReportsApi.pdfmake(data);
                }
            })
    }

    previewLB(data): Observable<any> {
        return this.viewCareerReportsApi.previewReport(data);
    }

    async careerType(): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let getSurvey = this.careerReportApi.careerType().subscribe(result => {
                resolve(result.data)
            }, error => {
              reject(error.message)
            }, () => {
              getSurvey.unsubscribe()
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/career-report.bloc.ts